import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

axios.defaults.baseURL = process.env.VUE_APP_KHAZAD_URI
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    games: null,
    releaseDates: [],
    feedDates: [],
    analytics: false,
    showCalendar: true
  },
  mutations: {
    updateGames (state, games) {
      state.games = games
    },
    updateReleaseDates (state, dates) {
      state.releaseDates = dates
    },
    appendReleaseDates (state, dates) {
      let rds = [...state.feedDates, ...dates]
      state.feedDates = rds
    },
    initFeedDates (state, dates) {
      state.feedDates = dates
    },
    updateAnalytics (state, status) {
      state.analytics = status
    },
    toggleCalendar (state) {
      state.showCalendar = !state.showCalendar
    },
    setCalendar (state, status) {
      state.showCalendar = status
    }
  },
  actions: {
    getGames ({ commit }) {
      axios.get('/games')
        .then((result) => {
          commit('updateGames', result.data)
        })
        .catch(console.error)
    },
    getGamesByDates ({ commit }, { startDate, endDate }) {
      axios.post('/games/gamesByDates', { startDate, endDate })
        .then((result) => {
          commit('updateGames', result.data)
        })
        .catch(console.error)
    },
    getGameById ({ commit }, id) {
      return axios.post('/games/game', { id })
        .then((result) => result.data)
    },
    getGameBySlug ({ commit }, slug) {
      return axios.post('/games/name', { slug })
        .then((result) => result.data)
    },
    getReleaseDates ({ commit }) {
      axios.get('/releaseDates')
        .then((result) => {
          commit('updateReleaseDates', result.data)
        })
        .catch(console.error)
    },
    getReleaseDatesByDates ({ commit }, {startDate, endDate, cb = () => { }}) {
      return axios.post('/releaseDates/aggregateByDates', { startDate, endDate })
        .then((result) => {
          commit('updateReleaseDates', result.data)
          cb()
        })
        .catch(console.error)
    },
    concatReleaseDatesByDates ({ commit }, {startDate, endDate, cb = () => { }}) {
      axios.post('/releaseDates/aggregateByDates', { startDate, endDate })
        .then((result) => {
          commit('appendReleaseDates', result.data)
          cb()
        })
        .catch(console.error)
    },
    concatReleaseDatesByStart ({ commit }, {startDate, cb = () => { }}) {
      axios.post('/releaseDates/aggregateByStart', { startDate })
        .then((result) => {
          commit('appendReleaseDates', result.data)
          cb()
        })
        .catch(console.error)
    },
    concatReleaseDatesByEnd ({ commit }, {endDate, cb = () => { }}) {
      return axios.post('/releaseDates/aggregateByEnd', { endDate })
        .then((result) => {
          commit('appendReleaseDates', result.data)
          cb()
        })
        .catch(console.error)
    },
    firstFeedLoad ({ commit }, {startDate, cb = () => { }}) {
      return axios.post('/releaseDates/aggregateByStart', { startDate })
        .then((result) => {
          commit('initFeedDates', result.data)
          cb()
        })
        .catch(console.error)
    },
    getReleaseDateById ({ commit }, id) {
      return axios.post('/releaseDates/releaseDate', { id })
        .then((result) => result.data)
    },
    getReleaseDatesByGameId ({ commit }, id) {
      return axios.get('/releaseDates/game/id/' + id)
        .then((result) => result.data)
    },
    getReleaseDateBySlug ({ commit }, slug) {
      return axios.post('/releaseDates/game/name', { slug })
        .then((result) => result.data)
    },
    getReleaseDatesByGameIgdbId ({ commit }, igdbId) {
      return axios.get('/releaseDates/game/igdbId/' + igdbId)
        .then((result) => result.data)
    },
    setAnalytics ({ commit }, analytics) {
      commit('updateAnalytics', analytics)
    },
    toggleCalendar ({ commit }) {
      commit('toggleCalendar')
    },
    setCalendar ({ commit }, status) {
      commit('setCalendar', status)
    }
  }
})
